class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      var cart_content = JSON.parse(document.querySelector('#cart-items-content').textContent);
      let updates = ''
      const bundleItem = event.target.closest('.cart-item').dataset.properties;
      console.log(bundleItem, 'bundleItem', cart_content)
      if (bundleItem) {
        const bundleItems = cart_content.items.filter(item => item.properties._bundle_pack == bundleItem ? item.properties._bundle_pack == bundleItem : item.properties._cb_number == bundleItem);
        updates = bundleItems.reduce((acc, item) => {
          acc[item.key] = 0;
          return acc;
        }, {});
        console.log('updates')
        console.log(updates)
        this.closest('cart-items').updateQuantity(this.dataset.index, 0, document.activeElement.getAttribute('name'), updates);
      } else {
        this.closest('cart-items').updateQuantity(this.dataset.index, 0, document.activeElement.getAttribute('name'));
      }
      document.addEventListener('cart:updated', async () => {
        if (typeof checkAndRemoveGiftIfAlone === 'function') {
          await checkAndRemoveGiftIfAlone();
        }
      }, { once: true });
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class PurchaseOption extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleDOMContentLoaded();
  }

  handleDOMContentLoaded() {
    const _this = this;
    this.miniCart = document.querySelector('mini-cart');
    const [handle] = this.dataset.handle.split('?');
    const index = this.dataset.index;
    fetch(`${window.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((data) => {
        this.cart = data;
        fetch(`${handle}.js`, {  // Syntax corrected: added comma after `${url}.js`
          method: 'GET'
        })
          .then(response => response.json())
          .then(data => {
            this.cart.items.forEach(item => {
              var lineItem = item;
              if (_this.dataset.key == item.key) {
                if (item.product_id == data.id) {

                  item['selling_plan_groups'] = data.selling_plan_groups;
                  item['sellGroup'] = [];
                  item['selling_plan_groups'].forEach(group => {
                    item['sellGroup'] = item['sellGroup'].concat(group.selling_plans);
                  });

                  // console.log(item['sellGroup'], "item['sellGroup']")
                  if (item['sellGroup'].length) {
                    if (this.miniCart) {
                      this.miniCart.cart_enableLoading()
                    }
                  }
                  const sellingPlanWrapDiv = document.createElement('div');
                  sellingPlanWrapDiv.classList.add('selling_plan_wrap');
                  var button = ''
                  var select = ''

                  if (lineItem.selling_plan_allocation) {
                    select = document.createElement('select');
                    select.classList.add('updated-selected-selling-option', 'selected-' + lineItem.key);

                    select.addEventListener('change', (event) => {
                      _this.updateItemSelling(lineItem.quantity, event.target.value, lineItem.key);
                    });
                  } else {
                    button += ` 
<div class="update_selling_plan button-update">             
                  ${this.dataset.buttonText} ${lineItem.sellGroup[0]?.price_adjustments[0].value}% ?
                </div>`
                  }

                  let optionsHTML = `
                  <optgroup label="ONE TIME PURCHASE">
                      <option value="">One time purchase</option>
                  </optgroup>  
                  <optgroup label="Subscribe and Save">
              `;
                  item.sellGroup.forEach(plan => {
                    optionsHTML += `
                      <option value="${plan.id}" ${plan.id == lineItem.selling_plan_allocation?.selling_plan.id ? 'selected' : ''}>${plan.name}</option>
                  `;
                  });
                  optionsHTML += `</optgroup>`;
                  if (item.sellGroup.length > 0) {
                    if (select) {
                      select.innerHTML = optionsHTML;

                      const label = document.createElement('label');
                      label.classList.add('visually-hidden');
                      label.htmlFor = `selling-plan-subscription-${lineItem.id}-${index}`;
                      label.textContent = 'Subscribe & save';
                      if (_this.firstChild) {
                        _this.removeChild(_this.firstChild);
                      }
                      sellingPlanWrapDiv.appendChild(label);
                      sellingPlanWrapDiv.appendChild(select);

                      if (this.miniCart) {
                        this.miniCart.cart_disableLoading()
                      }
                    } else {
                      sellingPlanWrapDiv.innerHTML = button
                      if (this.miniCart) {
                        this.miniCart.cart_disableLoading()
                      }
                      sellingPlanWrapDiv.querySelector('.update_selling_plan').addEventListener('click', () => {
                        _this.updateItemSelling(lineItem.quantity, lineItem.sellGroup[0].id, lineItem.key);
                      });
                    }
                    _this.appendChild(sellingPlanWrapDiv);
                  }
                }
              }
            });

            var purchaseOpt = document.querySelectorAll('purchase-option');
            //console.log(purchaseOpt.length, index)
            //if(purchaseOpt.length == index){
            purchaseOpt.forEach(option => {
              option.classList.remove('hidden');
            });
            //}
            if (purchaseOpt.length <= 0) {
              if (this.miniCart) {
                this.miniCart.cart_disableLoading()
              }
            }
            // console.log(purchaseOpt.length, index, 'purchaseOpt.length')



          })
          .catch(error => {
            // Handle any errors that occur during the fetch
            console.error('Error:', error);
          });

      })
  }
  updateItemSelling(qty, sellingID, variantId, e) {
    if (e) {
      e.preventDefault()
    }
    var cart_items = document.querySelector('cart-items');
    this.miniCart = document.querySelector('mini-cart');
    if (this.miniCart) {
      this.miniCart.cart_enableLoading();
    }
    fetch(`${window.routes.cart_change_url}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
      },
      body: JSON.stringify({ id: variantId, quantity: qty, selling_plan: sellingID })
    })
      .then((response) => response.json())
      .then((state) => {

        const _this = this
        const cartData = state;
        console.log(cartData, 'state');
        const free_gift = window.min_gift.free_git;
        const minPrice = window.min_gift.min_price;
        const free_gift2 = window.min_gift.free_git_2;
        const minPrice2 = window.min_gift.min_price_2;
        const isGiftAdded = cartData.items.find(item => item.id == free_gift);
        const isGiftAdded2 = cartData.items.find(item => item.id == free_gift2);

        const cartTotalExcludingGiftCard = cartData.items
          .filter(item => item.handle != "gift-card") // Exclude gift card
          .reduce((total, item) => total + item.line_price, 0); // Sum up remaining items' prices

        console.log("Cart total excluding gift card:", cartTotalExcludingGiftCard);
        console.log(minPrice, "minPrice");

        if (cartTotalExcludingGiftCard >= minPrice && free_gift != 0) {
          if (!isGiftAdded) {
            var items = [
              {
                quantity: 1,
                id: parseInt(free_gift),
                properties: {
                  _min_gift_product: true
                }
              }
            ]
            // console.log(items, 'items')
            fetch(`${window.routes.cart_add_url}.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
              },
              body: JSON.stringify({
                items
              })
            })
              .then((response) => response.json())
              .then((response) => {
                cartChangeSucess(_this, response);
              })
          } else {

            var cartPrice = cartTotalExcludingGiftCard
            if (isGiftAdded.discounted_price > 0) {
              var cartPrice = cartTotalExcludingGiftCard - isGiftAdded.discounted_price
            }


            if (cartPrice < minPrice && free_gift != 0) {
              const giftItem = cartData.items.filter(item => item.properties?._min_gift_product == true);
              if (giftItem.length) {
                fetch(`${window.routes.cart_change_url}.js`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                  },
                  body: JSON.stringify({
                    'id': giftItem[0].key,
                    'quantity': 0,
                    sections_url: window.location.pathname
                  })
                })
                  .then((response) => response.json())
                  .then((response) => {
                    cartChangeSucess(_this, response);
                  })
              }
            } else {
              cartChangeSucess(_this, cartData);
            }
          }
        } else {
          const giftItem = cartData.items.filter(item => item.properties?._min_gift_product == true);
          if (giftItem.length) {
            fetch(`${window.routes.cart_change_url}.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
              },
              body: JSON.stringify({
                'id': giftItem[0].key,
                'quantity': 0,
                sections: sections,
                sections_url: window.location.pathname
              })
            })
              .then((response) => response.json())
              .then((response) => {
                // console.log(response, 'response')
                cartChangeSucess(_this, response);
              })
          } else {
            cartChangeSucess(_this, cartData);
          }

        }
        setTimeout(() => {
          if (cartTotalExcludingGiftCard >= minPrice2 && free_gift2 != 0) {
            if (!isGiftAdded2) {
              var items = [
                {
                  quantity: 1,
                  id: parseInt(free_gift2),
                  properties: {
                    _min_gift_product: true
                  }
                }
              ];
              fetch(`${window.routes.cart_add_url}.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'xmlhttprequest'
                },
                body: JSON.stringify({
                  items
                })
              })
                .then((response) => response.json())
                .then((response) => {
                  cartChangeSucess(_this, response);
                });
            } else {
              var cartPrice = cartTotalExcludingGiftCard;
              if (isGiftAdded.discounted_price > 0) {
                cartPrice = cartTotalExcludingGiftCard - isGiftAdded.discounted_price;
              }

              if (cartPrice < minPrice && free_gift != 0) {
                const giftItem = cartData.items.filter(
                  item => item.properties?._min_gift_product === true
                );
                if (giftItem.length) {
                  fetch(`${window.routes.cart_change_url}.js`, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'xmlhttprequest'
                    },
                    body: JSON.stringify({
                      id: giftItem[0].key,
                      quantity: 0,
                      sections_url: window.location.pathname
                    })
                  })
                    .then((response) => response.json())
                    .then((response) => {
                      cartChangeSucess(_this, response);
                    });
                }
              } else {
                cartChangeSucess(_this, cartData);
              }
            }
          } else {
            const giftItem = cartData.items.filter(
              item => item.properties?._min_gift_product === true
            );
            if (giftItem.length) {
              fetch(`${window.routes.cart_change_url}.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'xmlhttprequest'
                },
                body: JSON.stringify({
                  id: giftItem[0].key,
                  quantity: 0,
                  sections: sections,
                  sections_url: window.location.pathname
                })
              })
                .then((response) => response.json())
                .then((response) => {
                  cartChangeSucess(_this, response);
                });
            } else {
              cartChangeSucess(_this, cartData);
            }
          }
        }, 500); // Delay of 500ms, adjust if needed


        // Buy 2 Get 1 Offer Logic
        const btg_gift = window.buy_gift?.btg_git;
        const btg_fpvarinat = window.buy_gift?.btg_variants;
        const GiftAdded = cartData.items.some(item => item.id == btg_gift);



        console.log(btg_gift, 'btg_gift cart');
        console.log(GiftAdded, 'GiftAdded');
        console.log(btg_fpvarinat, 'btg_fpvarinat cart');


        function cartChangeSucess(_this, parsedState) {
          if (_this.miniCart) {
            fetch(document.getElementById("mini-cart").dataset.url)
              .then((response) => response.text())
              .then((html) => {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                if (doc.querySelector('cart-items')?.dataset.count) {
                  const spanElements = document.querySelectorAll("#cart-icon-bubble span");
                  spanElements.forEach((span) => {
                    span.innerHTML = doc.querySelector('cart-items').dataset.count
                  });
                }
                document.getElementById("mini-cart").innerHTML =
                  _this.miniCart.getSectionInnerHTML(html, ".shopify-section");
                _this.miniCart.cart_disableLoading();
              })
          } else {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var c = doc.querySelector('#main-cart-items')
            document.querySelector('#main-cart-items').innerHTML = c.innerHTML;
            cart_items.cartPagedisableLoading();
          }
        }
      })
  }
}
customElements.define('purchase-option', PurchaseOption);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }
  onChange(event) {
    if (event.target === null) return;
    if (event.target.dataset.index) {
      var cart_content = JSON.parse(document.querySelector('#cart-items-content').textContent);
      let updates = ''
      const bundleItem = event.target.closest('.cart-item').dataset.properties;
      console.log(bundleItem, 'bundleItem', cart_content)
      if (bundleItem) {
        const bundleItems = cart_content.items.filter(item => item.properties._bundle_pack == bundleItem ? item.properties._bundle_pack == bundleItem : item.properties._cb_number == bundleItem);
        updates = bundleItems.reduce((acc, item) => {
          acc[item.key] = parseInt(event.target.value, 10);
          return acc;
        }, {});
        console.log(updates, "updates")
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), updates);
      } else {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
      }
    }
  }
  getSectionsToRender() {
    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping',
      });
    }
    if (document.querySelector('#main-cart-footer .free-gift_product')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-gift_product',
      });
    }

    return sections;
  }

  updateQuantity(line, quantity, name, updates) {

    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);
    var body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });
    var url = window.routes.cart_change_url
    if (updates) {
      let values = Object.values(updates);
      if (values.length > 0) {
        var url = window.routes.cart_update_url + '.js'
        body = JSON.stringify({
          updates,
          sections: sections,
          sections_url: window.location.pathname
        })
      }
    }
    console.log(body, "body")
    fetch(`${url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {

        const _this = this
        const cartData = JSON.parse(state);
        console.log(cartData, 'state');
        const free_gift = window.min_gift.free_git;
        const minPrice = window.min_gift.min_price;
        const free_gift2 = window.min_gift.free_git_2;
        const minPrice2 = window.min_gift.min_price_2;
        const isGiftAdded = cartData.items.find(item => item.id == free_gift);
        const isGiftAdded2 = cartData.items.find(item => item.id == free_gift2);
        // Buy 2 Get 1 Offer Logic
        const btg_gift = window.buy_gift?.btg_git;
        const btg_fpvarinat = window.buy_gift?.btg_variants;
        const GiftAdded = cartData.items.some(item => item.id == btg_gift);
        console.log(btg_gift, 'btg_gift cart');
        console.log(GiftAdded, 'GiftAdded');
        console.log(btg_fpvarinat, 'btg_fpvarinat cart');


        const cartTotalExcludingGiftCard = cartData.items
          .filter(item => item.handle != "gift-card") // Exclude gift card
          .reduce((total, item) => total + item.line_price, 0); // Sum up remaining items' prices
        console.log(cartData, "helo");
        console.log("Cart total excluding gift card:", cartTotalExcludingGiftCard);
        console.log(minPrice, "minPrice");

        if (btg_fpvarinat != 0 && btg_gift != 0) {

          setTimeout(() => {
            if (cartTotalExcludingGiftCard >= minPrice && free_gift != 0) {
              if (!isGiftAdded) {
                var items = [
                  {
                    quantity: 1,
                    id: parseInt(free_gift),
                    properties: {
                      _min_gift_product: true
                    }
                  }
                ]
                // console.log(items, 'items')
                fetch(`${window.routes.cart_add_url}.js`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                  },
                  body: JSON.stringify({
                    items,
                    sections: sections,
                    sections_url: window.location.pathname
                  })
                })
                  .then((response) => response.json())
                  .then((response) => {
                    // console.log(response, 'response')
                    cartChangeSucess(_this, response);
                  })
              } else {
                var cartPrice = cartTotalExcludingGiftCard
                if (isGiftAdded.discounted_price > 0) {
                  var cartPrice = cartTotalExcludingGiftCard - isGiftAdded.discounted_price
                }


                if (cartPrice < minPrice && free_gift != 0) {
                  const giftItem = cartData.items.filter(item => item.properties?._min_gift_product == true);
                  if (giftItem.length) {
                    fetch(`${window.routes.cart_change_url}.js`, {
                      method: 'POST',
                      credentials: 'same-origin',
                      headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                      },
                      body: JSON.stringify({
                        'id': giftItem[0].key,
                        'quantity': 0,
                        sections: sections,
                        sections_url: window.location.pathname
                      })
                    })
                      .then((response) => response.json())
                      .then((response) => {
                        //  console.log(response, 'response')
                        cartChangeSucess(_this, response);
                      })
                  }
                } else {

                  cartChangeSucess(_this, cartData);
                }
              }
            } else {

              const giftItem = cartData.items.filter(item => item.properties?._min_gift_product == true);
              if (giftItem.length) {
                fetch(`${window.routes.cart_change_url}.js`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                  },
                  body: JSON.stringify({
                    'id': giftItem[0].key,
                    'quantity': 0,
                    sections: sections,
                    sections_url: window.location.pathname
                  })
                })
                  .then((response) => response.json())
                  .then((response) => {
                    // console.log(response, 'response')
                    cartChangeSucess(_this, response);
                  })
              } else {
                cartChangeSucess(_this, cartData);
              }

            }
          }, 500); // Adjust delay (500ms) as needed

          setTimeout(() => {
            if (cartTotalExcludingGiftCard >= minPrice2 && free_gift2 != 0) {
              if (!isGiftAdded2) {
                var items = [
                  {
                    quantity: 1,
                    id: parseInt(free_gift2),
                    properties: {
                      _min_gift_product_2: true
                    }
                  }
                ];
                fetch(`${window.routes.cart_add_url}.js`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                  },
                  body: JSON.stringify({
                    items,
                    sections: sections,
                    sections_url: window.location.pathname
                  })
                })
                  .then((response) => response.json())
                  .then((response) => {
                    cartChangeSucess(_this, response);
                  });
              } else {
                var cartPrice = cartTotalExcludingGiftCard;
                if (isGiftAdded.discounted_price > 0) {
                  cartPrice = cartTotalExcludingGiftCard - isGiftAdded.discounted_price;
                }

                if (cartPrice < minPrice && free_gift != 0) {
                  const giftItem = cartData.items.filter(item => item.properties?._min_gift_product_2 === true);
                  if (giftItem.length) {
                    fetch(`${window.routes.cart_change_url}.js`, {
                      method: 'POST',
                      credentials: 'same-origin',
                      headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest'
                      },
                      body: JSON.stringify({
                        id: giftItem[0].key,
                        quantity: 0,
                        sections: sections,
                        sections_url: window.location.pathname
                      })
                    })
                      .then((response) => response.json())
                      .then((response) => {
                        cartChangeSucess(_this, response);
                      });
                  }
                } else {
                  cartChangeSucess(_this, cartData);
                }
              }
            } else {
              const giftItem = cartData.items.filter(item => item.properties?._min_gift_product_2 === true);
              if (giftItem.length) {
                fetch(`${window.routes.cart_change_url}.js`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                  },
                  body: JSON.stringify({
                    id: giftItem[0].key,
                    quantity: 0,
                    sections: sections,
                    sections_url: window.location.pathname
                  })
                })
                  .then((response) => response.json())
                  .then((response) => {
                    cartChangeSucess(_this, response);
                  });
              } else {
                cartChangeSucess(_this, cartData);
              }
            }
          }, 1000); // Adjust delay (500ms) as needed
          setTimeout(() => {
            if (btg_fpvarinat != 0 && btg_gift != 0) {
              // Find matching product that has quantity >= 2
              const hasMatchingProductWithMinQty = cartData.items.some(item => {
                const isMatch = btg_fpvarinat.includes(item.product_id.toString());
                const qtyEnough = item.quantity >= 2;
                console.log(item.product_id, item.quantity, '-> Match:', isMatch, '| Qty >= 2:', qtyEnough);
                return isMatch && qtyEnough;
              });
              console.log(hasMatchingProductWithMinQty, '→ hasMatchingProductWithMinQty');
              if (hasMatchingProductWithMinQty) {
                if (!GiftAdded) {
                  // Add the free gift
                  const items = [
                    {
                      quantity: 1,
                      id: parseInt(btg_gift),
                      properties: {
                        _buy_two_offer: true
                      }
                    }
                  ];

                  fetch(`${window.routes.cart_add_url}.js`, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'xmlhttprequest'
                    },
                    body: JSON.stringify({
                      items,
                      sections: sections,
                      sections_url: window.location.pathname
                    })
                  })
                    .then((response) => response.json())
                    .then((response) => {
                      cartChangeSucess(_this, response);
                    });
                }

                return;
              } else {
                // No qualifying product with quantity >= 2 → REMOVE gift
                const btg_giftItem = cartData.items.find(item => item.properties?._buy_two_offer === true);
                if (btg_giftItem) {
                  fetch(`${window.routes.cart_change_url}.js`, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'xmlhttprequest'
                    },
                    body: JSON.stringify({
                      id: btg_giftItem.key,
                      quantity: 0,
                      sections: sections,
                      sections_url: window.location.pathname
                    })
                  })
                    .then((response) => response.json())
                    .then((response) => {
                      cartChangeSucess(_this, response);
                    });

                } else {
                  cartChangeSucess(_this, cartData);
                }
              }
            } else {
              // Default: no gift config or variants set → Remove any lingering gift
              const btg_giftItem = cartData.items.find(item => item.properties?._buy_two_offer === true);
              if (btg_giftItem) {
                fetch(`${window.routes.cart_change_url}.js`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                  },
                  body: JSON.stringify({
                    id: btg_giftItem.key,
                    quantity: 0,
                    sections: sections,
                    sections_url: window.location.pathname
                  })
                })
                  .then((response) => response.json())
                  .then((response) => {
                    cartChangeSucess(_this, response);
                  });
              } else {
                cartChangeSucess(_this, cartData);
              }
            }
          }, 1500); // Adjust delay (500ms) as needed 


        }
        else {



          if (cartTotalExcludingGiftCard >= minPrice && free_gift != 0) {
            if (!isGiftAdded) {
              var items = [
                {
                  quantity: 1,
                  id: parseInt(free_gift),
                  properties: {
                    _min_gift_product: true
                  }
                }
              ]
              // console.log(items, 'items')
              fetch(`${window.routes.cart_add_url}.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                },
                body: JSON.stringify({
                  items,
                  sections: sections,
                  sections_url: window.location.pathname
                })
              })
                .then((response) => response.json())
                .then((response) => {
                  // console.log(response, 'response')
                  cartChangeSucess(_this, response);
                })
            } else {

              var cartPrice = cartTotalExcludingGiftCard
              if (isGiftAdded.discounted_price > 0) {
                var cartPrice = cartTotalExcludingGiftCard - isGiftAdded.discounted_price
              }


              if (cartPrice < minPrice && free_gift != 0) {
                const giftItem = cartData.items.filter(item => item.properties?._min_gift_product == true);
                if (giftItem.length) {
                  fetch(`${window.routes.cart_change_url}.js`, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                    },
                    body: JSON.stringify({
                      'id': giftItem[0].key,
                      'quantity': 0,
                      sections: sections,
                      sections_url: window.location.pathname
                    })
                  })
                    .then((response) => response.json())
                    .then((response) => {
                      //  console.log(response, 'response')
                      cartChangeSucess(_this, response);
                    })
                }
              } else {

                cartChangeSucess(_this, cartData);
              }
            }
          } else {

            const giftItem = cartData.items.filter(item => item.properties?._min_gift_product == true);
            if (giftItem.length) {
              fetch(`${window.routes.cart_change_url}.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                },
                body: JSON.stringify({
                  'id': giftItem[0].key,
                  'quantity': 0,
                  sections: sections,
                  sections_url: window.location.pathname
                })
              })
                .then((response) => response.json())
                .then((response) => {
                  // console.log(response, 'response')
                  cartChangeSucess(_this, response);
                })
            } else {
              cartChangeSucess(_this, cartData);
            }

          }

          setTimeout(() => {
            if (cartTotalExcludingGiftCard >= minPrice2 && free_gift2 != 0) {
              if (!isGiftAdded2) {
                var items = [
                  {
                    quantity: 1,
                    id: parseInt(free_gift2),
                    properties: {
                      _min_gift_product_2: true
                    }
                  }
                ];
                fetch(`${window.routes.cart_add_url}.js`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                  },
                  body: JSON.stringify({
                    items,
                    sections: sections,
                    sections_url: window.location.pathname
                  })
                })
                  .then((response) => response.json())
                  .then((response) => {
                    cartChangeSucess(_this, response);
                  });
              } else {
                var cartPrice = cartTotalExcludingGiftCard;
                if (isGiftAdded.discounted_price > 0) {
                  cartPrice = cartTotalExcludingGiftCard - isGiftAdded.discounted_price;
                }

                if (cartPrice < minPrice && free_gift != 0) {
                  const giftItem = cartData.items.filter(item => item.properties?._min_gift_product_2 === true);
                  if (giftItem.length) {
                    fetch(`${window.routes.cart_change_url}.js`, {
                      method: 'POST',
                      credentials: 'same-origin',
                      headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest'
                      },
                      body: JSON.stringify({
                        id: giftItem[0].key,
                        quantity: 0,
                        sections: sections,
                        sections_url: window.location.pathname
                      })
                    })
                      .then((response) => response.json())
                      .then((response) => {
                        cartChangeSucess(_this, response);
                      });
                  }
                } else {
                  cartChangeSucess(_this, cartData);
                }
              }
            } else {
              const giftItem = cartData.items.filter(item => item.properties?._min_gift_product_2 === true);
              if (giftItem.length) {
                fetch(`${window.routes.cart_change_url}.js`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                  },
                  body: JSON.stringify({
                    id: giftItem[0].key,
                    quantity: 0,
                    sections: sections,
                    sections_url: window.location.pathname
                  })
                })
                  .then((response) => response.json())
                  .then((response) => {
                    cartChangeSucess(_this, response);
                  });
              } else {
                cartChangeSucess(_this, cartData);
              }
            }
          }, 500); // Adjust delay (500ms) as needed
        }




        fetch(`${window.routes.cart_url}.js`)
          .then(res => res.json())
          .then(cart => {
            const allItemsAreGifts = cart.items.length > 0 && cart.items.every(
              item =>
                item.properties &&
                (item.properties._min_gift_product === true || item.properties._min_gift_product_2 === true)
            );

            if (allItemsAreGifts) {
              const updatesObj = {};

              cart.items.forEach(item => {
                updatesObj[item.id] = 0;
              });

              fetch(`${window.routes.cart_update_url}.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'xmlhttprequest'
                },
                body: JSON.stringify({
                  updates: updatesObj,
                  sections,
                  sections_url: window.location.pathname
                })
              })
                .then(res => res.json())
                .then(response => {
                  cartChangeSucess(this, response);
                });
            }
          });

        return;
        function cartChangeSucess(_this, parsedState) {

          // console.log(parsedState, 'parsedState', 'gbjb hvn h jh ')
          _this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (parsedState.errors) {
            _this.updateErrorLiveRegions(line, parsedState.errors);
          }
          _this.getSectionsToRender().forEach((section => {
            const element = document.getElementById(section.id);
            if (element) {
              const elementToReplace = element.querySelector(section.selector) || element;

              if (elementToReplace && parsedState.sections[section.section]) {
                elementToReplace.innerHTML =
                  _this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              }
            }
          }));

          _this.updateQuantityLiveRegions(line, parsedState.item_count);

          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();
          _this.disableLoading();
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              cart: parsedState
            }
          }));
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
  }

  updateErrorLiveRegions(line, message) {
    // console.log('updateErrorLiveRegions', line, message)

    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  updateQuantityLiveRegions(line, itemCount) {
    // console.log('updateQuantityLiveRegions', line, 'itemCount => ', itemCount)
    // console.log(this.currentItemCount, 'this.currentItemCount')
    if (this.currentItemCount === itemCount && this.quantityUpdateFailed) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          );
      }
    }

    this.currentItemCount = itemCount;

    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  cartPageenableLoading() {
    const cartPage = document.querySelector('cart-items.page-width.section--padding');
    if (cartPage) cartPage.classList.add('cart__items--disabled');
  }

  cartPagedisableLoading() {
    const cartPage = document.querySelector('cart-items.page-width.section--padding');
    if (cartPage) cartPage.classList.remove('cart__items--disabled');
  }

  enableLoading(line) {
    // console.log('enableLoading')
    document.body.classList.add('cart__items--loading');
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');

    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.body.classList.remove('cart__items--loading');
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
    // console.log('disableLoading')
  }

  renderContents(parsedState) {
    console.log('parsedState', parsedState)
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
  }
}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${window.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();

    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${window.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';

          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }

}

customElements.define('shipping-calculator', ShippingCalculator);
class featuredDiscount extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));

  }
  handleClick() {
    console.log(this)
    const discountValue = this.dataset.quantity;
    console.log('Discount value:', discountValue);

    // Update quantity input value in the closest <li> parent this
    const listItem = this.closest('li') || this.closest('tr');
    if (listItem) {
      const quantityInput = listItem.querySelector('quantity-input input');
      if (quantityInput) {
        quantityInput.value = discountValue;

        const event = new Event('change', { bubbles: true });
        quantityInput.dispatchEvent(event);
      }
    }
  }
}


customElements.define("feature-discount", featuredDiscount);